// extracted by mini-css-extract-plugin
export default {"tags":"searchtag_tags__H1Gbu","tags__lista":"searchtag_tags__lista__Pki6V"};